export const SIDEBAR = 'sidebar';
export const TOP = 'top';
export const TAB = 'tab';
export const PROJECT_TITLE = 'projectTitle';

export type NavigationContainer = typeof SIDEBAR | typeof TOP | typeof TAB | typeof PROJECT_TITLE;
